import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress ResizeObserver loop error BEFORE React loads
// This error is benign and caused by Radix UI Select components
// It doesn't affect functionality - it's a known browser quirk
const suppressResizeObserverError = () => {
  const resizeObserverErr = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
    constructor(callback) {
      super((entries, observer) => {
        // Wrap callback in requestAnimationFrame to prevent the loop error
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
};

if (typeof window !== 'undefined') {
  suppressResizeObserverError();

  // Block Chrome's "Install FieldReady" prompt on DESKTOP only.
  // Phones/tablets (touch + small viewport) still get the full PWA
  // install experience, which is what field workers need. Desktop
  // users get a normal browser tab and won't accidentally install a
  // standalone Chrome app window.
  const isDesktopChrome = () => {
    // Modern UA Client Hints (Chrome 90+ / Edge / Opera)
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
      return !navigator.userAgentData.mobile;
    }
    // Fallback: no touch + wide viewport = desktop
    const noTouch = (navigator.maxTouchPoints || 0) === 0;
    const wide = window.matchMedia('(min-width: 1024px)').matches;
    return noTouch && wide;
  };
  if (isDesktopChrome()) {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
    });
  }

  // Also suppress the error overlay
  window.addEventListener('error', (event) => {
    if (event.message?.includes?.('ResizeObserver') || 
        event.error?.message?.includes?.('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  }, true);

  // Suppress console errors for ResizeObserver
  const originalError = console.error;
  console.error = (...args) => {
    const errorString = args[0]?.toString?.() || '';
    if (errorString.includes('ResizeObserver')) {
      return;
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
